(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qstrips-deporte"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.qs-dep').forEach(function(root){
    if(root.dataset.qsInit) return; root.dataset.qsInit='1';
    var cartUrl = root.dataset.cartUrl || '/cart';
    root.querySelectorAll('[data-qs-scroll]').forEach(function(btn){
      btn.addEventListener('click',function(){ var t=document.getElementById(btn.getAttribute('data-qs-scroll')); if(t) t.scrollIntoView({behavior:'smooth',block:'start'}); });
    });
    function addToCart(variantId,btn){
      if(!variantId){ alert('Configura el ID de variante de este pack en el editor para activar el botón.'); return; }
      var original=btn.textContent; btn.disabled=true; btn.textContent='Añadiendo…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(e){throw e;}); return r.json(); })
        .then(function(){ window.location.href=cartUrl; })
        .catch(function(err){ btn.disabled=false; btn.textContent=original; alert((err&&err.description)?err.description:'No se pudo añadir al carrito. Revisa el ID de variante.'); });
    }
    root.querySelectorAll('.qs-add').forEach(function(btn){ btn.addEventListener('click',function(){ addToCart(btn.getAttribute('data-qs-variant'),btn); }); });
    var sticky=root.querySelector('[data-qs-sticky]');
    if(sticky){ var onScroll=function(){ sticky.classList.toggle('is-visible', window.scrollY>600 && window.innerWidth<=860); }; window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll); onScroll(); }
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12}); root.querySelectorAll('.qs-rev').forEach(function(el){io.observe(el);}); } else { root.querySelectorAll('.qs-rev').forEach(function(el){el.classList.add('in');}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qstrips-dormir"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.qs-dor').forEach(function(root){
    if(root.dataset.qsInit) return; root.dataset.qsInit='1';
    var cartUrl = root.dataset.cartUrl || '/cart';
    root.querySelectorAll('[data-qs-scroll]').forEach(function(btn){
      btn.addEventListener('click',function(){ var t=document.getElementById(btn.getAttribute('data-qs-scroll')); if(t) t.scrollIntoView({behavior:'smooth',block:'start'}); });
    });
    function addToCart(variantId,btn){
      if(!variantId){ alert('Configura el ID de variante de este pack en el editor para activar el botón.'); return; }
      var original=btn.textContent; btn.disabled=true; btn.textContent='Añadiendo…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(e){throw e;}); return r.json(); })
        .then(function(){ window.location.href=cartUrl; })
        .catch(function(err){ btn.disabled=false; btn.textContent=original; alert((err&&err.description)?err.description:'No se pudo añadir al carrito. Revisa el ID de variante.'); });
    }
    root.querySelectorAll('.qs-add').forEach(function(btn){ btn.addEventListener('click',function(){ addToCart(btn.getAttribute('data-qs-variant'),btn); }); });
    var sticky=root.querySelector('[data-qs-sticky]');
    if(sticky){ var onScroll=function(){ sticky.classList.toggle('is-visible', window.scrollY>600 && window.innerWidth<=860); }; window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll); onScroll(); }
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12}); root.querySelectorAll('.qs-rev').forEach(function(el){io.observe(el);}); } else { root.querySelectorAll('.qs-rev').forEach(function(el){el.classList.add('in');}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qstrips-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.qs-root');
  if(!root||root.dataset.qsInit)return; root.dataset.qsInit='1';
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* Hero air canvas */
  var hero=root.querySelector('[data-qs-hero]');
  var canvas=root.querySelector('[data-qs-air]');
  if(canvas&&hero){
    var ctx=canvas.getContext('2d'),W,H,parts=[],mode='sport';
    function rz(){W=canvas.width=hero.offsetWidth;H=canvas.height=hero.offsetHeight;}
    function mk(){parts=[];var n=Math.min(90,Math.round(W/16));for(var i=0;i<n;i++)parts.push({x:Math.random()*W,y:Math.random()*H,s:.4+Math.random()*1.4,v:.4+Math.random()*1.1,a:.1+Math.random()*.4,ph:Math.random()*6.28});}
    rz();mk();addEventListener('resize',function(){rz();mk();});
    function draw(){ctx.clearRect(0,0,W,H);for(var i=0;i<parts.length;i++){var p=parts[i];p.x+=p.v;p.y+=Math.sin(p.x*0.006+p.ph)*0.5;if(p.x>W+20){p.x=-20;p.y=Math.random()*H;}ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(p.x-p.v*14,p.y-Math.sin(p.x*0.006+p.ph)*0.5*14);ctx.strokeStyle='rgba(10,10,10,'+p.a+')';ctx.lineWidth=p.s;ctx.lineCap='round';ctx.stroke();}requestAnimationFrame(draw);}
    if(!reduce)draw();
    var tg=root.querySelector('[data-qs-toggle]');
    if(tg)tg.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;mode=b.dataset.mode;tg.querySelectorAll('button').forEach(function(x){var on=x===b;x.classList.toggle('on',on);x.setAttribute('aria-selected',on);});root.querySelectorAll('[data-copy]').forEach(function(c){c.hidden=c.dataset.copy!==mode;});});
  }

  /* Meter */
  var mC=root.querySelector('[data-qs-meter]'),slider=root.querySelector('[data-qs-slider]');
  if(mC&&slider){
    var mx=mC.getContext('2d'),mW,mH,mp=[],open=1;
    var mVal=root.querySelector('[data-qs-meterval]'),mLbl=root.querySelector('[data-qs-meterlbl]');
    function mrz(){var r=mC.parentElement.getBoundingClientRect();mW=mC.width=r.width;mH=mC.height=r.height;mmk();}
    function mmk(){mp=[];for(var i=0;i<70;i++)mp.push({x:Math.random()*mW,y:Math.random()*mH,v:.5+Math.random()*1.2,ph:Math.random()*6.28,s:.5+Math.random()*1.3});}
    function md(){mx.clearRect(0,0,mW,mH);var g=0.2+open*0.8;for(var i=0;i<mp.length;i++){var p=mp[i];p.x+=p.v*(0.4+g);var w=Math.sin(p.x*0.02+p.ph)*(6+(1-g)*20);if(p.x>mW+10){p.x=-10;p.y=Math.random()*mH;}mx.beginPath();mx.moveTo(p.x,p.y+w);mx.lineTo(p.x-p.v*12,p.y+w);mx.strokeStyle='rgba(255,255,255,'+(0.12+g*0.35)+')';mx.lineWidth=p.s;mx.lineCap='round';mx.stroke();}requestAnimationFrame(md);}
    mrz();addEventListener('resize',mrz);if(!reduce)md();
    function upd(){var v=slider.value/100;open=v;mLbl.textContent=v>0.5?'flujo de aire · con QSTRIPS':'flujo de aire · fosas cerradas';mVal.textContent=v>0.5?'Más aire':'Menos aire';}
    slider.addEventListener('input',upd);upd();
  }

  /* FAQ */
  root.querySelectorAll('[data-qs-faq] .qs-faq-q').forEach(function(q){q.addEventListener('click',function(){var it=q.parentElement,a=it.querySelector('.qs-faq-a');var op=it.classList.toggle('open');a.style.maxHeight=op?a.scrollHeight+'px':0;});});

  /* Reveal */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
  root.querySelectorAll('.qs-rev').forEach(function(el){io.observe(el);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qstrips-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.qs-pd').forEach(function(root){
    if(root.dataset.qsInit) return; root.dataset.qsInit='1';
    var id = root.id.replace('qs-pd-','');
    var priceEl = root.querySelector('#qs-pd-price-'+id);
    var wasEl   = root.querySelector('#qs-pd-was-'+id);
    var idEl    = root.querySelector('#qs-pd-id-'+id);
    var stickyPrice = root.querySelector('#qs-pd-stickyprice-'+id);

    /* Elegir pack → actualiza precio + variante enviada */
    root.querySelectorAll('input[name="qs-pack"]').forEach(function(r){
      r.addEventListener('change', function(){
        if(idEl) idEl.value = r.value;
        if(priceEl) priceEl.textContent = r.getAttribute('data-price') || '';
        var cmp = r.getAttribute('data-compare');
        if(wasEl){ if(cmp){ wasEl.textContent = cmp; wasEl.hidden = false; } else { wasEl.textContent=''; wasEl.hidden = true; } }
        if(stickyPrice) stickyPrice.textContent = r.getAttribute('data-price') || '';
      });
    });

    /* Galería: cambiar imagen principal */
    var mainImg = root.querySelector('#qs-pd-mainimg-'+id);
    root.querySelectorAll('.qs-pd-thumb').forEach(function(t){
      t.addEventListener('click', function(){
        var src = t.getAttribute('data-qs-src');
        if(mainImg && src) mainImg.src = src;
        root.querySelectorAll('.qs-pd-thumb').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* Sticky visible al hacer scroll en móvil */
    var sticky = root.querySelector('[data-qs-sticky]');
    if(sticky){
      var onScroll=function(){ sticky.classList.toggle('is-visible', window.scrollY>640 && window.innerWidth<=860); };
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll); onScroll();
    }

    /* Reveal */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.12});
      root.querySelectorAll('.qs-rev').forEach(function(el){io.observe(el);});
    } else { root.querySelectorAll('.qs-rev').forEach(function(el){el.classList.add('in');}); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
